import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { HiX } from 'react-icons/hi';
import { useTheme } from '../Flowbite/ThemeContext';
import { useToastContext } from './ToastContext';
export var ToastToggle = function ToastToggle(_ref) {
  var className = _ref.className,
    _ref$xIcon = _ref.xIcon,
    XIcon = _ref$xIcon === void 0 ? HiX : _ref$xIcon;
  var _useToastContext = useToastContext(),
    duration = _useToastContext.duration,
    isClosed = _useToastContext.isClosed,
    isRemoved = _useToastContext.isRemoved,
    setIsClosed = _useToastContext.setIsClosed,
    setIsRemoved = _useToastContext.setIsRemoved;
  var theme = useTheme().theme.toast.toggle;
  var handleClick = function handleClick() {
    setIsClosed(!isClosed);
    setTimeout(function () {
      return setIsRemoved(!isRemoved);
    }, duration);
  };
  return _jsx("button", {
    "aria-label": "Close",
    onClick: handleClick,
    type: "button",
    className: classNames(theme.base, className),
    children: _jsx(XIcon, {
      className: theme.icon
    })
  });
};